export enum IngredientsOrderTypes {
  alph = 'alph',
  dryasc = 'dryasc',
  drydesc = 'drydesc',
  priceasc = 'priceasc',
  pricedesc = 'pricedesc',
}

export const IngredientTypeOrders: { value: IngredientsOrderTypes; labelKey: string }[] = [
  { value: IngredientsOrderTypes.alph, labelKey: 'order_alphabetical' },
  { value: IngredientsOrderTypes.dryasc, labelKey: 'order_dm_asc' },
  { value: IngredientsOrderTypes.drydesc, labelKey: 'order_dm_desc' },
  { value: IngredientsOrderTypes.priceasc, labelKey: 'order_price_asc' },
  { value: IngredientsOrderTypes.pricedesc, labelKey: 'order_price_desc' },
];
